
import {Statistic} from "./components/statistic/Statistic";
import {MainActions} from "./components/mainActions/MainActions";
import { useEffect, useState } from 'react';
import {ActivityType, CurrentActivityType, userLogin} from "../../models/commonModels"
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { auth } from '../../store/app-slice/AppSlice';
import { HelpOrphanHome } from "./components/HelpOrphanHome/HelpOrphanHome";
import { TelegramChannel } from "./components/telegramChannel/TelegramChannel";
import { Banner } from "./components/Banner/Banner";
import { Gifts } from "./components/Gifts/Gifts";
import { MaxChannel } from "./components/telegramChannel/MaxChannel";
import { StatisticView } from "./components/StatisticView/StatisticView";

export const MainPage = () => {
const dispatch:any = useAppDispatch();
const navigation = useNavigate()
    const [user,setUser] = useState<userLogin|null>(()=>{
        const savedUser = localStorage.getItem("currentUser")
        if(savedUser==null) return null;
        const initialValue:userLogin = JSON.parse(savedUser)
        return initialValue;})
    const token = useAppSelector(state=>state.appStore.token)
    const [isAdmin,setIsAdmin] = useState<boolean> (()=>{
        const jwtRole:string|null = localStorage.getItem("jwt")
        if(jwtRole!=null){
            const arr:string[]=JSON.parse(jwtRole) as string[]
            debugger
            return arr.includes("ROLE_ADMIN")
        }
        return false
    })

useEffect(()=>{ 
    if(user==null||user.email?.length==0||user.pswd?.length==0){
       //localStorage.clear();
       setUser(null)
    }else{
        if(token==null){
            dispatch(auth(user))
            return
        }
    }
},[user])

    return (
        <div>
            <Statistic isRegister={user!=null} isAdmin={isAdmin}/>
            {user!=null&&<MainActions/>}
            {/* <Gifts/> */}
            <TelegramChannel/>
            <MaxChannel/>
            {/* <Banner/> */}
            {user!=null&&<StatisticView/>}
            <HelpOrphanHome/>
        </div>
    );
}